export const roomTypeOptions = [
  { value: "ensuite", label: "Ensuite" },
  { value: "studio", label: "Studio" },
  { value: "shared", label: "Shared Room" },
  { value: "private", label: "Private Room" },
  { value: "apartment", label: "Apartment" },
  { value: "non_ensuite", label: "Non-Ensuite" },
  { value: "twin_ensuite", label: "Twin Ensuite" },
  { value: "twin_studio", label: "Twin Studio" },
  { value: "one_bed", label: "1 Bedroom" },
  { value: "two_bed", label: "2 Bedroom" },
  { value: "three_bed", label: "3 Bedroom" },
  { value: "four_bed", label: "4 Bedroom" },
  { value: "five_bed", label: "5 Bedroom" },
  { value: "five_plus_bed", label: "5+ Bedroom" },
  { value: "shared_room", label: "Shared Room" },
  { value: "private_room", label: "Private Room" },
  { value: "entire_place", label: "Entire Place" },
  { value: "twodio", label: "Twodio" },
  { value: "threedio", label: "Threedio" },
  { value: "dorm", label: "Dormitory" },
  { value: "deluxe_ensuite", label: "Deluxe Ensuite" },
  { value: "premium_ensuite", label: "Premium Ensuite" },
  { value: "deluxe_non_ensuite", label: "Deluxe Non-Ensuite" },
  { value: "premium_non_ensuite", label: "Premium Non-Ensuite" },
  { value: "twin_non_ensuite", label: "Twin Non-Ensuite" },
  { value: "lite", label: "Lite" },
  { value: "classic", label: "Classic" },
  { value: "premium", label: "Premium" },
  { value: "deluxe", label: "Deluxe" },
  { value: "accessible", label: "Accessible" },
  { value: "classic_courtyard", label: "Classic Courtyard" },
  { value: "classic_plus", label: "Classic Plus" },
  { value: "premium_plus", label: "Premium Plus" },
  { value: "ultimate_vita", label: "Ultimate Vita" },
  { value: "lite_plus", label: "Lite Plus" },
  { value: "twin_room", label: "Twin Room" },
  { value: "cluster", label: "Cluster" },
  { value: "penthouse", label: "Penthouse" },
  { value: "enhanced", label: "Enhanced" },
  { value: "elite", label: "Elite" },
  { value: "duo", label: "Duo" },
  { value: "essential", label: "Essential" },
  { value: "essential_extra", label: "Essential Extra" },
];
